import React from "react";

const ProductTile = ({className, productCode, heroThumbnail, title, href}) => {
  const productTileClasses = ["product-tile", "product-tile--compact", className].join(" ");

  return (
      <div className="swiper-slide">
        <div className={productTileClasses} data-product-id={productCode}>
          <div className="product-tile__img-container">
            <a className="product-tile__img-link" href={href}>
              <img
                className="product-tile__img" src={heroThumbnail} alt={title}
              />
            </a>
          </div>

          <div className="product-tile__content">
            <div className="product-tile__section-alternate">
              <div className="product-tile__alt-slot product-tile__alt-slot--slide-out">
                <div className="product-tile__section-details">
                  <a href={href} className="product-tile__detail-name">{title}</a>
                  <p className="product-tile__detail-code">
                    Product Code: {productCode}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default ProductTile;
